
export const ActionTypes = {
  INIT: "INIT",
  SEARCH: "SEARCH",
  SORT: "SORT",
  PAGE: "PAGE",
  PAGE_LIMIT: "PAGE_LIMIT",
  FILTER: "FILTER",
};

export const Actions = {
  INIT: (state) => ({ type: ActionTypes.INIT, state }),
  SEARCH: (keyword) => ({ type: ActionTypes.SEARCH, keyword }),
  SORT: ({ sortDir, sortBy }) => ({ type: ActionTypes.SORT, sortBy, sortDir }),
  PAGE: (page) => ({ type: ActionTypes.PAGE, page }),
  PAGE_LIMIT: (limit) => ({ type: ActionTypes.PAGE_LIMIT, limit }),
  FILTER: (appliedFilter) => ({ type: ActionTypes.FILTER, appliedFilter }),
};
